module.exports = __webpack_public_path__ + "static/hero-ed8f1a4280c2dba2b3ba5b2df2b556cb.jpg";